import { useEffect, useState } from 'react';
import { getDashboardStatisticsQuery } from '../../api/services/dashboard.service';
import moment from 'moment';
import useApi from '../../hook/useApi';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { resetReportShipmentFormAction } from '../../store';
import { PATHS } from '../../constants/paths';

const monthlyFilter = [
  { label: 'All', value: 'all' },
  { label: 'Jan', value: '01' },
  { label: 'Feb', value: '02' },
  { label: 'Mar', value: '03' },
  { label: 'Apr', value: '04' },
  { label: 'May', value: '05' },
  { label: 'Jun', value: '06' },
  { label: 'Jul', value: '07' },
  { label: 'Aug', value: '08' },
  { label: 'Sep', value: '09' },
  { label: 'Oct', value: '10' },
  { label: 'Nov', value: '11' },
  { label: 'Dec', value: '12' },
];

export const useDashboard = () => {
  const { payments } = useSelector((state) => state);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const reportShipmentHandler = () => {
    dispatch(resetReportShipmentFormAction());

    // if (
    //   user?.entity?.isManualPayment === true ||
    //   (Array.isArray(payments?.payments) && payments?.payments.length > 0)
    // ) {
    navigate(PATHS.TEST_REPORT_SHIPMENT);
    // } else {
    //   toast.dismiss();
    //   toast.error('Please add a payment method', { duration: TOAST_TIME });
    // }
  };

   function generateYearsArray() {
    const startYear = 2023;
    const endYear = 2030;
    const defaultYear = new Date().getFullYear(); 
    const yearsArray = [];
    
    // Add years from startYear to endYear
    for (let i = startYear; i <= endYear; i++) {
      yearsArray.push({ 
        label: i.toString(), 
        value: i.toString(),
        selected: i === defaultYear 
      });
    }
    
    return yearsArray;
  }
  
  
   function getDefaultYearDateRange() {
    const defaultYear = new Date().getFullYear();
    return {
      startDate: `${defaultYear}-01-01`,
      endDate: `${defaultYear}-12-31`
    };
  }

  const yearsFilterArray = generateYearsArray();

  const defaultYear = yearsFilterArray.find(year => year.selected)?.value || new Date().getFullYear().toString();
  const [overviewTab, setOverviewTab] = useState('shipment');
  const [selectedMonth, setSelectedMonth] = useState(`all`);
  const [selectedYear, setSelectedYear] = useState(defaultYear);
  
  // Get date range for the current year
  const { startDate: defaultStartDate, endDate: defaultEndDate } = getDefaultYearDateRange();
  const [startDate, setStartDate] = useState(defaultStartDate);
  const [endDate, setEndDate] = useState(defaultEndDate);

  const [getdata, loading, error, data] = useApi(getDashboardStatisticsQuery);
  const currentYear = !Number.isNaN(Number(selectedYear))
    ? Number(selectedYear)
    : new Date().getFullYear();
  const overviewChartXAxisData = [
    `${currentYear} January`,
    `${currentYear} February`,
    `${currentYear} March`,
    `${currentYear} April`,
    `${currentYear} May`,
    `${currentYear} June`,
    `${currentYear} July`,
    `${currentYear} August`,
    `${currentYear} September`,
    `${currentYear} October`,
    `${currentYear} November`,
    `${currentYear} December`,
  ];
  // New function to generate dynamic X-axis labels from actual data
  function generateDynamicXAxisLabels() {
    // Always show all 12 months for the selected year
    const monthNames = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];
    
    return monthNames.map(monthName => `${currentYear} ${monthName}`);
  }
  
  // Get the appropriate data source based on the selected tab
  const getDataSourceForCurrentTab = () => {
    switch (overviewTab) {
      case 'payment':
        return data?.dashboardStatistics?.monthlyBilling;
      case 'manualClaims':
        return data?.dashboardStatistics?.monthlyManualClaimsCount;
      case 'shipmentClaims':
        return data?.dashboardStatistics?.monthlyShipmentClaimsCount;
      case 'billing':
        return data?.dashboardStatistics?.monthlyBilling;
      case 'shipment':
        return data?.dashboardStatistics?.monthlyShipmentsCount;
      case 'entities':
        return data?.dashboardStatistics?.monthlyEntitiesCount;
      default:
        return data?.dashboardStatistics?.monthlyShipmentsCount;
    }
  };
  
  // Generate dynamic X-axis labels for all 12 months
  const dynamicXAxisLabels = generateDynamicXAxisLabels();
  
  // Transform data to match the dynamic labels with zeros for missing months
  const getDynamicChartData = () => {
    const monthlyData = Array(12).fill(0);
    const dataSource = getDataSourceForCurrentTab();
    
    if (dataSource && dataSource.length > 0) {
      dataSource.forEach(entry => {
        const date = new Date(entry.month);
        // Only include data for the current selected year
        if (date.getFullYear() === currentYear) {
          const monthIndex = date.getMonth();
          monthlyData[monthIndex] = entry.count || entry.totalPremium || 0;
        }
      });
    }
    
    return monthlyData;
  };
  
  const dynamicChartData = getDynamicChartData();

  useEffect(() => {
    getdata({
      endDate: endDate,
      startDate: startDate,
    });
  }, [endDate, startDate]);

  const updateDateRange = (month, year) => {
    if (month === 'all' && year === 'all') {
      setStartDate(`${yearsFilterArray[1].value}-01-01`);
      setEndDate(
        `${yearsFilterArray[yearsFilterArray.length - 1].value}-12-31`
      );
    } else if (month === 'all') {
      setStartDate(`${year}-01-01`);
      setEndDate(`${year}-12-31`);
    } else if (year === 'all') {
      setStartDate(`${yearsFilterArray[1].value}-${month}-01`);
      setEndDate(
        `${
          yearsFilterArray[yearsFilterArray.length - 1].value
        }-${month}-${moment(
          `${month}-${yearsFilterArray[yearsFilterArray.length - 1].value}`,
          'MM-YYYY'
        ).daysInMonth()}`
      );
    } else {
      setStartDate(`${year}-${month}-01`);
      setEndDate(
        `${year}-${month}-${moment(
          `${month}-${year}`,
          'MM-YYYY'
        ).daysInMonth()}`
      );
    }
  };

  const handleYearChange = (event) => {
    setSelectedYear(event.target.value);
    updateDateRange(selectedMonth, event.target.value);
  };
  const handleMonthChange = (event) => {
    setSelectedMonth(event.target.value);
    updateDateRange(event.target.value, selectedYear);
  };
  const handleOverviewTab = (value) => {
    setOverviewTab(value);
  };

  function getMonthlyCounts(data) {
    const monthlyCounts = Array(12).fill(0);
    data?.forEach((entry) => {
      const month = new Date(entry?.month).getMonth();
      monthlyCounts[month] += entry?.count ? entry?.count : entry?.totalPremium;
    });

    return monthlyCounts;
  }

  const overviewChartTabs = {
    payment: getMonthlyCounts([]),
    manualClaims: getMonthlyCounts(
      data?.dashboardStatistics?.monthlyManualClaimsCount
    ),
    shipmentClaims: getMonthlyCounts(
      data?.dashboardStatistics?.monthlyShipmentClaimsCount
    ),
    billing: getMonthlyCounts(data?.dashboardStatistics?.monthlyBilling),
    shipment: getMonthlyCounts(
      data?.dashboardStatistics?.monthlyShipmentsCount
    ),
  };
  const chartData = overviewChartTabs[overviewTab] || [];
  function formatNumber(value, isCurrency = false) {
    const formatter = new Intl.NumberFormat('en-US', {
      style: isCurrency ? 'currency' : 'decimal',
      currency: 'USD',
      maximumFractionDigits: 2,
    });

    if (value >= 1_000_000_000) {
      return formatter.format(value / 1_000_000_000) + 'B';
    } else if (value >= 1_000_000) {
      return formatter.format(value / 1_000_000) + 'M';
    } else if (value >= 1_000) {
      return formatter.format(value / 1_000) + 'K';
    } else {
      return formatter.format(value);
    }
  }
  
  // Remove this duplicate function - it's already defined above
  // const getDynamicChartData = () => {
  //   if (!currentDataSource || currentDataSource.length === 0) {
  //     return chartData; // Fallback to default
  //   }
  //
  //   // Map data to match the labels
  //   return currentDataSource.map(
  //     (entry) => entry.count || entry.totalPremium || 0
  //   );
  // };

  // Use the already defined dynamicChartData from above

  const overviewChartOptions = {
    title: {
      // text: `CPIC Data for 2024`,
      left: 'center',
      top: '13%',
      textStyle: {
        fontSize: 18,
        fontWeight: 'Normal',
      },
    },
    height: '90%',
    width: '95%',
    tooltip: {
      trigger: 'axis',
      show: true,
      axisPointer: {
        show: false,
        type: 'cross',
        label: {
          backgroundColor: '#DAEFFF',
          color: '#000000',
          fontWeight: '550',
        },
      },
    },
    legend: {
      show: false,
      data: [`${overviewTab}`],
    },
    toolbox: {
      show: false,
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      top: '7%',
      containLabel: true,
    },
    xAxis: {
      show: true,
      type: 'category',
      data: dynamicXAxisLabels,
      axisTick: { show: false },
      axisLine: { show: false },
      axisLabel: {
        rotate: 45,
        fontSize: 12,
      },
    },
    yAxis: {
      show: true,
      axisLabel: { show: true },
      splitNumber: 4,
    },
    series: [
      {
        name: overviewTab,
        type: 'bar',
        data: dynamicChartData, // Dynamic data
        color: [' #77553D'], // Bar color matching the image
        label: {
          show: true,
          position: 'top',
          formatter: (params) => formatNumber(params.value),
        },
        barWidth: '40%', // Adjust bar width
      },
    ],
  };

  const ShipmentChartOptions = {
    tooltip: {
      trigger: 'item',
      axisPointer: {
        type: 'shadow',
      },
      borderColor: 'transparent',
      formatter: function (params) {
        const { seriesName, value, color, name: month } = params;
        return `
            <div>
              <div><strong>${month}</strong></div>
              <div>
                <span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${color};"></span>
                ${seriesName}: ${value}
              </div>
            </div>`;
      },
    },
    legend: {
      show: false,
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true,
    },
    xAxis: [
      {
        type: 'category',
        data: [
          'Jan',
          'Feb',
          'Mar',
          'Apr',
          'May',
          'Jun',
          'Jul',
          'Aug',
          'Sep',
          'Oct',
          'Nov',
          'Dec',
        ],
        axisTick: {
          show: false,
        },
        axisLine: {
          show: false,
        },
      },
    ],
    yAxis: [
      {
        show: true,
        axisLabel: {
          show: false,
        },
        splitNumber: 3,
        type: 'value',
      },
    ],
    series: [
      {
        name: 'Entities',
        type: 'bar',
        stack: 'entity',
        emphasis: {
          focus: 'series',
        },
        barWidth: '40%',
        data: getMonthlyCounts(data?.dashboardStatistics?.monthlyEntitiesCount),
        color: ['#F7BA1E'],
        itemStyle: {
          borderRadius: [5, 5, 0, 0],
        },
      },
    ],
  };

  return {
    data: data?.dashboardStatistics,
    overviewTab,
    overviewChartOptions,
    ShipmentChartOptions,
    handleOverviewTab,
    selectedMonth,
    reportShipmentHandler,
    monthlyFilter,
    selectedYear,
    yearsFilterArray,
    handleMonthChange,
    handleYearChange,
    loading,
  };
};
